import { Mapper } from './mapper';

export const ModalidadeAprendiz = Mapper.from([
  ['direta', 'Direta'],
  ['indireta', 'Indireta'],
]);
